import { of } from 'rxjs'
import { NavigationNode, ContentNode, EmiRequest } from 'models'

import Constants from 'api-constants'

const {
    GENERATE_AVAILABLE_RECORDINGS_BY_MONTH_REQUESTS,
    GET_AVAILABLE_RECORDINGS_BY_NAME,
    GET_SCHEDULED_STANDALONE_EVENT_RECORDINGS_BY_DATE,
    // GET_SCHEDULED_SERIES_RECORDINGS_BY_NAME,
} = Constants.customRequests
const {
    GET_CONTINUE_WATCHING_RECORDINGS,
    // GET_AVAILABLE_SERIES_RECORDINGS_BY_NAME,
    GET_FAVORITE_RECORDINGS,
} = Constants.emiRequests
const {
    AVAILABLE_RECORDINGS_BY_NAME,
    // AVAILABLE_SERIES_RECORDINGS_BY_NAME,
    CONTINUE_WATCHING_RECORDINGS,
    FAVORITE_RECORDINGS,
    SCHEDULED_STANDALONE_EVENT_RECORDINGS_BY_DATE,
    SCHEDULED_SERIES_RECORDINGS_BY_NAME,
} = Constants.requestIds
const {
    RECORDINGS_AVAILABLE_EVENTS_BY_DATE,
    RECORDINGS_AVAILABLE_BY_NAME,
    // RECORDINGS_AVAILABLE_SERIES_BY_NAME,
    RECORDINGS_CONTINUE_WATCHING,
    RECORDINGS_FAVORITES,
    RECORDINGS_SCHEDULED,
} = Constants.nodeIds

export default class ConfigurationApi {
    constructor(config) {
        this.config = config
    }

    getConfig() {
        return of({})
    }
    shouldUpgrade(appVersion) {
        // simply return of(false) since this service/platform does not offer forceUpgrade capabilities
        return of(false)
    }

    /**
     * Returns custom nodes and requests for the navigation map
     *
     * @returns {Observable<EmiModuleConfiguration>}
     */
    getCustomNavigationMap() {
        const bodyType = (this.config && this.config.recordingsBodyType) || 'list'
        const addIntlKey = bodyType !== 'wall'
        return of({
            navMap: {
                'root-recordings': new NavigationNode({
                    id: 'root-recordings',
                    parent: 'root',
                    labels: {
                        default: '',
                    },
                    intlKey: { tag: 'root-recordings' },
                    translateLabel: true,
                    children: [
                        RECORDINGS_AVAILABLE_EVENTS_BY_DATE,
                        RECORDINGS_AVAILABLE_BY_NAME,
                        // RECORDINGS_AVAILABLE_SERIES_BY_NAME, // No serie recording for Starhub
                        RECORDINGS_CONTINUE_WATCHING,
                        RECORDINGS_FAVORITES,
                        RECORDINGS_SCHEDULED,
                    ],
                }),

                [RECORDINGS_AVAILABLE_EVENTS_BY_DATE]: new ContentNode({
                    id: RECORDINGS_AVAILABLE_EVENTS_BY_DATE,
                    parent: 'root-recordings',
                    labels: {
                        default: '',
                    },
                    intlKey: { tag: RECORDINGS_AVAILABLE_EVENTS_BY_DATE },
                    translateLabel: true,
                    highlight: { data: [], type: 'dvr-storage' },
                    body: {
                        data: [
                            {
                                id: GENERATE_AVAILABLE_RECORDINGS_BY_MONTH_REQUESTS,
                            },
                        ],
                    },
                }),

                [RECORDINGS_AVAILABLE_BY_NAME]: new ContentNode({
                    id: RECORDINGS_AVAILABLE_BY_NAME,
                    parent: 'root-recordings',
                    labels: {
                        default: '',
                    },
                    intlKey: { tag: RECORDINGS_AVAILABLE_BY_NAME },
                    translateLabel: true,
                    highlight: { data: [], type: 'dvr-storage' },
                    body: {
                        type: bodyType,
                        data: [{ id: AVAILABLE_RECORDINGS_BY_NAME }],
                    },
                }),

                /* No serie recording for Starhub
                [RECORDINGS_AVAILABLE_SERIES_BY_NAME]: new ContentNode({
                    id: RECORDINGS_AVAILABLE_SERIES_BY_NAME,
                    parent: 'root-recordings',
                    labels: {
                        default: '',
                    },
                    intlKey: { tag: RECORDINGS_AVAILABLE_SERIES_BY_NAME },
                    translateLabel: true,
                    highlight: { data: [], type: 'dvr-storage' },
                    body: {
                        type: bodyType,
                        data: [{ id: AVAILABLE_SERIES_RECORDINGS_BY_NAME }],
                    },
                }),
                */

                [RECORDINGS_CONTINUE_WATCHING]: new ContentNode({
                    id: RECORDINGS_CONTINUE_WATCHING,
                    parent: 'root-recordings',
                    labels: {
                        default: '',
                    },
                    intlKey: { tag: RECORDINGS_CONTINUE_WATCHING },
                    translateLabel: true,
                    highlight: { data: [], type: 'dvr-storage' },
                    body: {
                        type: bodyType,
                        data: [{ id: CONTINUE_WATCHING_RECORDINGS }],
                    },
                }),

                [RECORDINGS_FAVORITES]: new ContentNode({
                    id: RECORDINGS_FAVORITES,
                    parent: 'root-recordings',
                    labels: {
                        default: '',
                    },
                    intlKey: { tag: RECORDINGS_FAVORITES },
                    translateLabel: true,
                    highlight: { data: [], type: 'dvr-storage' },
                    body: {
                        type: bodyType,
                        data: [{ id: FAVORITE_RECORDINGS }],
                    },
                }),

                [RECORDINGS_SCHEDULED]: new ContentNode({
                    id: RECORDINGS_SCHEDULED,
                    parent: 'root-recordings',
                    labels: {
                        default: '',
                    },
                    intlKey: { tag: RECORDINGS_SCHEDULED },
                    translateLabel: true,
                    highlight: { data: [], type: 'dvr-storage' },
                    body: {
                        data: [
                            SCHEDULED_STANDALONE_EVENT_RECORDINGS_BY_DATE,
                            SCHEDULED_SERIES_RECORDINGS_BY_NAME,
                        ].map((id) => ({ id })),
                    },
                }),
            },
            requests: {
                [GENERATE_AVAILABLE_RECORDINGS_BY_MONTH_REQUESTS]: new EmiRequest({
                    id: GENERATE_AVAILABLE_RECORDINGS_BY_MONTH_REQUESTS,
                    value: GENERATE_AVAILABLE_RECORDINGS_BY_MONTH_REQUESTS,
                }),

                [AVAILABLE_RECORDINGS_BY_NAME]: new EmiRequest({
                    id: AVAILABLE_RECORDINGS_BY_NAME,
                    value: GET_AVAILABLE_RECORDINGS_BY_NAME,
                    intlKey: addIntlKey ? { tag: AVAILABLE_RECORDINGS_BY_NAME } : {},
                }),

                /*  No serie recording for Starhub
                [AVAILABLE_SERIES_RECORDINGS_BY_NAME]: new EmiRequest({
                    id: AVAILABLE_SERIES_RECORDINGS_BY_NAME,
                    value: GET_AVAILABLE_SERIES_RECORDINGS_BY_NAME,
                    intlKey: addIntlKey ? { tag: AVAILABLE_SERIES_RECORDINGS_BY_NAME } : {},
                }),
                */

                [CONTINUE_WATCHING_RECORDINGS]: new EmiRequest({
                    id: CONTINUE_WATCHING_RECORDINGS,
                    value: GET_CONTINUE_WATCHING_RECORDINGS,
                    intlKey: addIntlKey ? { tag: CONTINUE_WATCHING_RECORDINGS } : {},
                }),

                [FAVORITE_RECORDINGS]: new EmiRequest({
                    id: FAVORITE_RECORDINGS,
                    value: GET_FAVORITE_RECORDINGS,
                    intlKey: addIntlKey ? { tag: FAVORITE_RECORDINGS } : {},
                }),

                [SCHEDULED_STANDALONE_EVENT_RECORDINGS_BY_DATE]: new EmiRequest({
                    id: SCHEDULED_STANDALONE_EVENT_RECORDINGS_BY_DATE,
                    value: GET_SCHEDULED_STANDALONE_EVENT_RECORDINGS_BY_DATE,
                    intlKey: {
                        tag: SCHEDULED_STANDALONE_EVENT_RECORDINGS_BY_DATE,
                    },
                    translateLabel: true,
                }),

                /* No serie recording for Starhub
                [SCHEDULED_SERIES_RECORDINGS_BY_NAME]: new EmiRequest({
                    id: SCHEDULED_SERIES_RECORDINGS_BY_NAME,
                    value: GET_SCHEDULED_SERIES_RECORDINGS_BY_NAME,
                    intlKey: {
                        tag: SCHEDULED_SERIES_RECORDINGS_BY_NAME,
                    },
                    translateLabel: true,
                }),*/
            },
        })
    }

    /**
     * Get Sources of data provided by IFS proxy for this backend
     * @returns {Object}
     */
    getProxyMetadataSourceConfig() {
        return {
            channels: false,
            programs: true,
            subscriptions: true,
            dvr: false,
        }
    }

    isConnectedInOperatorNetwork = () => of(true)
}
